import axios from "@/plugins/axios";

export default {
  getImage(id) {
    return axios.get(`/product_images/${id}`);
  },
  getImageList(product_id) {
    return axios.get(`/products/${product_id}/images`);
  },

  addImage(product_id, { description, file }) {
    const formData = new FormData();
    formData.append("description", description);
    formData.append("file", file);
    return axios.post(`/products/${product_id}/images`, formData, {
      "Content-Type": "multipart/form-data",
    });
  },
  updateImage(id, { description, description_cache, dependent_id }) {
    // Note: CANNOT replace actual image
    return axios.post(`/product_images/${id}`, {
      description,
      description_cache,
      product_id: dependent_id,
    });
  },
  saveDefaultImages(imageList) {
    return axios.post("/product_image_defaults", {
      images: imageList,
    });
  },
  deleteImage(id) {
    return axios.delete(`/product_images/${id}`);
  },
  deleteImageList(idList) {
    return axios.delete("/product_images", {
      data: { image_list: idList },
    });
  },
};
